var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPtedandpixicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65565",
    "data-name": "Grupo 65565",
    transform: "translate(-1104 -1192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_15500",
    "data-name": "Ret\\xE2ngulo 15500",
    transform: "translate(1104 1192)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65550",
    "data-name": "Grupo 65550",
    transform: "translate(4418 7081.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95499",
    "data-name": "Caminho 95499",
    d: "M108.063,515.811v2a.94.94,0,0,0,1.88,0v-2.9a.941.941,0,0,0-.94-.94h-.94a.931.931,0,0,0-.389.041.941.941,0,0,0-.338,1.592.932.932,0,0,0,.338.2.949.949,0,0,0,.389.042Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95500",
    "data-name": "Caminho 95500",
    d: "M120.713,527.9a2.62,2.62,0,0,0-3.3-1.19c-.9.34-2,.76-3.21,1.09a2.753,2.753,0,0,0-.17-1.64,2.717,2.717,0,0,0-1.82-1.59,3.3,3.3,0,0,0-1.38-.08,9.773,9.773,0,0,1-6.81-1.61,6.986,6.986,0,0,0-3.46-1.26,8.747,8.747,0,0,0-2.9.52.911.911,0,0,0-.323.172.93.93,0,0,0-.3,1,1,1,0,0,0,1.18.62,6.1,6.1,0,0,1,2.34-.43,5.723,5.723,0,0,1,2.54,1,12.013,12.013,0,0,0,6.33,2,12.457,12.457,0,0,0,1.66-.12,1.541,1.541,0,0,1,.62,0,.912.912,0,0,1,.668.828.925.925,0,0,1-.058.372,1.257,1.257,0,0,1-.73.6,6.574,6.574,0,0,1-2.07.3,9.676,9.676,0,0,1-2.53-.3.941.941,0,0,0-.48,1.82,12.625,12.625,0,0,0,3,.35,24.021,24.021,0,0,0,8.56-1.88.77.77,0,0,1,1,.31.722.722,0,0,1-.29.94,18.254,18.254,0,0,1-9.1,2.41,19.453,19.453,0,0,1-9-2.53,4.184,4.184,0,0,0-3-.57.94.94,0,0,0,.24,1.84.963.963,0,0,0,.24,0,2.694,2.694,0,0,1,1.59.41,21.428,21.428,0,0,0,9.89,2.76,20.06,20.06,0,0,0,10-2.64,2.582,2.582,0,0,0,1.07-3.5Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#142249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95501",
    "data-name": "Caminho 95501",
    d: "M109,522.661a6.34,6.34,0,1,0-4.473-1.857A6.335,6.335,0,0,0,109,522.661Zm0-10.78a4.449,4.449,0,1,1-3.147,1.3A4.45,4.45,0,0,1,109,511.881Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#142249"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPtedandpixicon);
export default __webpack_public_path__ + "static/media/LPtedandpixicon.c318564f2af8bf14c77c9a15601f32b1.svg";
export { ForwardRef as ReactComponent };